import React from "react";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { useLocation } from "react-router-dom";
import Container from "@mui/material/Container";
import { customBreakpointsMax } from "app/theme";
import { CtaCommonBtn } from "app/components/cta-common-btn";
import PublisherSmallCtaIcon from "app/assets/vectors/jsx/PublisherSmallCtaIcon";
import PublisherMediumCtaIcon from "app/assets/vectors/jsx/PublisherMediumCtaIcon";
import { ReactComponent as FooterLinkDiscoverSectors } from "app/assets/vectors/FooterLinkDiscoverSectors.svg";
import { ReactComponent as FooterLinkDiscoverLocations } from "app/assets/vectors/FooterLinkDiscoverLocations.svg";
import { ReactComponent as FooterLinkDiscoverSectorsHover } from "app/assets/vectors/FooterLinkDiscoverSectorsHover.svg";
import { ReactComponent as FooterLinkDiscoverOrganisations } from "app/assets/vectors/FooterLinkDiscoverOrganisations.svg";
import { ReactComponent as PublisherFooterLinkAIDAExplorer } from "app/assets/vectors/PublisherFooterLinkAIDAExplorer.svg";
import { ReactComponent as FooterLinkDiscoverLocationsHover } from "app/assets/vectors/FooterLinkDiscoverLocationsHover.svg";
import { ReactComponent as FooterLinkSearchFilterActivities } from "app/assets/vectors/FooterLinkSearchFilterActivities.svg";
import { ReactComponent as FooterLinkDiscoverOrganisationsHover } from "app/assets/vectors/FooterLinkDiscoverOrganisationsHover.svg";
import { ReactComponent as PublisherFooterLinkDiscoverLocations } from "app/assets/vectors/PublisherFooterLinkDiscoverLocations.svg";
import { ReactComponent as FooterLinkSearchFilterActivitiesHover } from "app/assets/vectors/FooterLinkSearchFilterActivitiesHover.svg";
import { ReactComponent as PublisherFooterLinkDiscoverOrganisations } from "app/assets/vectors/PublisherFooterLinkDiscoverOrganisations.svg";

const ResponsiveCTAs: React.FC = () => {
  const mobile = useMediaQuery("(max-width: 743px)");
  const tablet = useMediaQuery("(max-width: 1439px)");
  const location = useLocation();

  const publisher =
    location.pathname.startsWith("/publisher") ||
    location.pathname.startsWith("/data-hub");

  const tabletLinks = [
    {
      label: "Publish to IATI",
      link: "/publisher",
      bgIcon: <PublisherMediumCtaIcon />,
    },
    {
      label: publisher ? "See AIDA Explorer" : "Search for Locations",
      link: publisher ? "/explorer" : "/explorer/locations",
      bgIcon: publisher ? (
        <PublisherFooterLinkAIDAExplorer />
      ) : (
        <FooterLinkDiscoverLocations />
      ),
      bgIconHover: publisher ? (
        <PublisherFooterLinkDiscoverLocations />
      ) : (
        <FooterLinkDiscoverLocationsHover />
      ),
    },
    {
      label: publisher ? "Search for Locations" : "Search for Sectors",
      link: publisher ? "/explorer/locations" : "/explorer/sectors",
      bgIcon: publisher ? (
        <PublisherFooterLinkDiscoverLocations />
      ) : (
        <FooterLinkDiscoverSectors />
      ),
      bgIconHover: publisher ? (
        <PublisherFooterLinkDiscoverLocations />
      ) : (
        <FooterLinkDiscoverSectorsHover />
      ),
    },
    {
      label: publisher
        ? "Search for Organisations"
        : "Search & Filter Activities",
      link: publisher ? "/explorer/organisations" : "/explorer/activities",
      bgIcon: publisher ? (
        <PublisherFooterLinkDiscoverOrganisations />
      ) : (
        <FooterLinkSearchFilterActivities />
      ),
      bgIconHover: publisher ? (
        <PublisherFooterLinkDiscoverOrganisations />
      ) : (
        <FooterLinkSearchFilterActivitiesHover />
      ),
    },
  ];

  const mobileLinks = [
    {
      label: "AIDA Publisher",
      link: "/publisher",
      bgIcon: <PublisherSmallCtaIcon />,
    },
    {
      label: publisher ? "AIDA Explorer" : "See Organisations",
      link: publisher ? "/explorer" : "/explorer/organisations",
      bgIcon: publisher ? (
        <PublisherFooterLinkAIDAExplorer />
      ) : (
        <FooterLinkDiscoverOrganisations />
      ),
      bgIconHover: publisher ? (
        <PublisherFooterLinkAIDAExplorer />
      ) : (
        <FooterLinkDiscoverOrganisationsHover />
      ),
    },
    {
      label: publisher ? "See Locations" : "See Sectors",
      link: publisher ? "/explorer/locations" : "/explorer/sectors",
      bgIcon: publisher ? (
        <PublisherFooterLinkDiscoverLocations />
      ) : (
        <FooterLinkDiscoverSectors />
      ),
      bgIconHover: publisher ? (
        <PublisherFooterLinkDiscoverLocations />
      ) : (
        <FooterLinkDiscoverSectorsHover />
      ),
    },
    {
      label: publisher ? "See Organisations" : "See Activities",
      link: publisher ? "/explorer/organisations" : "/explorer/activities",
      bgIcon: publisher ? (
        <PublisherFooterLinkDiscoverOrganisations />
      ) : (
        <FooterLinkSearchFilterActivities />
      ),
      bgIconHover: publisher ? (
        <PublisherFooterLinkDiscoverOrganisations />
      ) : (
        <FooterLinkSearchFilterActivitiesHover />
      ),
    },
  ];

  return (
    <React.Fragment>
      {tablet ? (
        <Container
          maxWidth="lg"
          disableGutters
          sx={{
            padding: "0 30px",
            paddingBottom: "40px !important",
            [customBreakpointsMax.mobile]: {
              padding: "0 24px",
              paddingBottom: "20px",
            },
          }}
        >
          <Box
            sx={{
              gap: "20px",
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              [customBreakpointsMax.tablet]: {
                "> a": { flex: "1" },
              },
              [customBreakpointsMax.mobile]: {
                display: "grid",
                flexWrap: "wrap",
                gridTemplateColumns: "1fr 1fr",
              },
            }}
          >
            {(mobile ? mobileLinks : tabletLinks).map((link) => (
              <CtaCommonBtn
                {...link}
                key={link.label}
                variant="footer"
                bgColor={
                  link.link === "/publisher" || publisher ? "green" : "blue"
                }
              />
            ))}
          </Box>
        </Container>
      ) : null}
    </React.Fragment>
  );
};

export default ResponsiveCTAs;
